module.exports = __webpack_public_path__ + "img/alurbadgeweb.a22d1733.svg";